import axios from 'axios'

export const submitSongsData=songsData=>{
    // console.log(songsData)
    axios({
        url:`https://${process.env.REACT_APP_URL_PORT}/admin`,
        method:'POST',
        data:songsData
    })
    .then(res=>console.log(res.data))
    .catch(err=>console.log(err))
}   